jQuery(document).ready(function ($) {
    ({
        init: function () {
            this.blog_slider();
        },
        blog_slider: function () {
            var section = $('.section-article');
            var slider = section.find('.card-list-slider');
            var item = slider.find('.card-item');
            if (item.length > 2) {
                slider.removeClass('row');
                slider.bxSlider({
                    speed: 1200,
                    pause: 9000,
                    slideWidth: 600,
                    minSlides: $(window).width() > 575 ? 2 : 1,
                    maxSlides: 2,
                    slideMargin: 0,
                    moveSlides: 1,
                    onSliderLoad: function (current) {
                        var pageritem = section.find('.bx-pager-item');
                        var len = pageritem.length;
                        pageritem.each(function () {
                            var index = $(this).index();
                            $(this).css('width', 100 / len * (index + 1) + '%')
                        })
                    },
                });
            }
        },
        load: function () {
            $(window).load(function () {

            })
        },
        resize: function () {
            var t = this;
            $(window).resize(function () {
            })
        }
    }).init()
});